'use client'
import { ElementType, ReactNode, useState } from 'react'
import { CollapseContext } from './collapseContext'
import CollapseToggle from './CollapseToggle'
import CollapseMenu from './CollapseMenu'

export type CollapseProps = {
  as?: ElementType
  open?: boolean
  className?: string
  children: ReactNode
  toggleCollapse?: () => void
  showAll?: any
}

const Collapse = ({ children, open, toggleCollapse,showAll }: CollapseProps) => {
  const [collapseOpen, setCollapseOpen] = useState<boolean>(false)
  const handleCollapse = () => {
    setCollapseOpen(!collapseOpen)
  }
  return (
    <CollapseContext.Provider
      value={{
        open: open ?? collapseOpen,
        handleCollapse: toggleCollapse ?? handleCollapse,
        showAll: showAll,
      }}
    >
      {children}
    </CollapseContext.Provider>
  )
}

export default Object.assign(Collapse, {
  Toggle: CollapseToggle,
  Menu: CollapseMenu,
})
